import React, { Component } from 'react';
import { connect } from 'react-redux';

class NessunQuesito extends Component {
    render() {
        const { ufficioSelezionato } = this.props;
        const isUfficio = ufficioSelezionato != null && (parseInt(ufficioSelezionato, 10) < 500000);

        if (isUfficio) {
            return (<div className="quesito__nessunQuesito">
                <svg viewBox="0 0 91.2 79.7" className="quesito__nessunQuesito__logo">
                    <g>
                        <path d="M84.5,68.7c2.4,3.8,4.3,7.2,6.7,11c-2.4-0.5-4.3-1-6.7-1.4c-4.3-1-8.2-1.4-12.5-2.4c-0.5,0-1,0-1.4,0c-9.1,1.9-17.8,1-25.4-3.8c-5.8-3.8-9.6-8.6-11-15.8c-1.4-7.7,1-14.4,6.2-19.7s11.5-8.2,18.7-8.6c7.2-1,13.9,0.5,20.2,4.3s10.1,9.1,11.5,16.3c1,6.7-1,13-5.3,18.2C85.4,67.7,85,68.2,84.5,68.7z M52.8,54.3c0-2.9-2.4-4.8-4.8-4.8c-2.9,0-4.8,2.4-4.8,4.8c0,2.9,2.4,4.8,4.8,4.8S52.8,56.7,52.8,54.3z M77.3,59.1c2.9,0,4.8-2.4,4.8-4.8c0-2.9-2.4-4.8-4.8-4.8c-2.9,0-5.3,2.4-5.3,4.8C72.5,56.7,74.4,59.1,77.3,59.1z M67.2,54.3c0-2.9-2.4-4.8-5.3-4.8s-4.8,2.4-4.8,4.8c0,2.9,2.4,4.8,4.8,4.8C65.3,59.1,67.7,56.7,67.2,54.3z" />
                        <path d="M15.4,42.3c-1,1.4-1.4,2.9-2.4,4.3c2.4-0.5,4.8-1,6.7-1.4c1,0,1.4,0,2.4,0c2.4,0.5,5.3,1,7.7,1c0.5,0,0.5,0,1,0c-0.5,1.9-0.5,4.3-1,6.2c-1.4,0-2.9,0-4.3-0.5c-1,0-1.9-0.5-2.9-0.5c-2.4-1-4.8,0-6.7,0.5c-5.3,1-10.1,1.9-15.4,2.9H0c0-0.5,0.5-0.5,0.5-1c1.9-2.9,4.3-6.2,6.2-9.6c0.5-0.5,0.5-1,0-1.4C2.4,38,0,31.7,0,25c0.5-7.7,4.3-13.4,10.1-18.2c5.3-3.8,11-6.2,17.8-6.7c8.6-0.5,16.3,1.4,23.5,6.7c5.3,3.8,8.6,9.1,9.6,15.8c0,0.5,0,1,0,1.9c-1.9,0.5-4.3,0.5-6.2,1c0-1-0.5-1.9-0.5-3.4c-1.4-5.3-4.8-9.1-9.6-12C35,4.4,22.1,5.3,13.4,12.5c-4.3,3.8-7.2,8.6-7.2,14.4c0,4.3,1.9,8.2,5.3,11.5C13,39.9,14.4,40.9,15.4,42.3z" />
                    </g>
                    <g>
                        <path d="M27.8,30c0-1.7,0.2-3,0.6-4c0.4-1,1.2-2,2.3-3c1.1-1,1.8-1.8,2.2-2.4c0.4-0.6,0.5-1.3,0.5-1.9c0-2-0.9-3.1-2.8-3.1c-0.9,0-1.6,0.3-2.1,0.8c-0.5,0.6-0.8,1.3-0.8,2.3h-5.3c0-2.3,0.8-4.1,2.2-5.4c1.5-1.3,3.5-2,6-2c2.6,0,4.6,0.6,6,1.9s2.1,3,2.1,5.3c0,1-0.2,2-0.7,2.9c-0.5,0.9-1.3,1.9-2.4,3l-1.5,1.4c-0.9,0.9-1.4,1.9-1.6,3.1L32.4,30H27.8zM27.3,35.5c0-0.8,0.3-1.5,0.8-2c0.6-0.5,1.3-0.8,2.1-0.8c0.9,0,1.6,0.3,2.1,0.8c0.6,0.5,0.8,1.2,0.8,2c0,0.8-0.3,1.5-0.8,2c-0.5,0.5-1.2,0.8-2.1,0.8s-1.6-0.3-2.1-0.8S27.3,36.3,27.3,35.5z" />
                    </g>
                </svg>

                <svg viewBox="0 0 203 122" className="quesito__nessunQuesito__freccia">
                    <path d="M192.8,0.1L171.7,16l15.3-5.1l-0.5,1.6l-1.8,5.4c-9.9,30.6-30,54.7-63.2,75.9c-26.9,17.2-56.2,25.5-89.4,25.5c-10.2,0-20.7-0.8-31.7-2.4c11.1,3.4,22.9,5.2,35.2,5.2c10.8,0,22.3-1.3,34.1-3.9c56.1-12.4,101.9-49.9,122.8-105.5L203,24.8L192.8,0.1z" />
                </svg>


                <div className="quesito__nessunQuesito__testo">
                    <b>In quest'area non sono presenti quesiti</b> <br /><br />
                    <span>Se hai bisogno di assistenza crea un quesito tramite il bottone in alto a destra. <br /> Un team di esperti è disponibile per ogni tua esigenza.</span>
                </div>
            </div>);
            } else {
                return null;
            };

    }
}

const mapStateToProps = state => {
    return {
        ufficioSelezionato: state.ufficioSelezionato
    };
};

export default connect(
    mapStateToProps,
    null
)(NessunQuesito);


